// extracted by mini-css-extract-plugin
module.exports = {"input":"Search-module--input--1VIcp","list":"Search-module--list--1GgD1","listItemContainer":"Search-module--listItemContainer--2qpV3","listItem":"Search-module--listItem--1RPET"};